import styled from 'styled-components'

export const ViewRoot = styled.div`
  /* no extra styles needed at root; layout is driven by children */
`

export const ContentContainer = styled.div`
  display: flex;
  height: 100vh;
  padding-top: 4.3rem;
`

export const Sidebar = styled.div`
  padding: 1rem;
  padding-bottom: ${({ $extraBottomPadding }) =>
    $extraBottomPadding ? '70px' : '1rem'};
  background: var(--sidebar-bg);
  color: var(--sidebar-text-color);
  transition: 0.5s ease box-shadow;
  border-right: 1px solid var(--medium-grey);
  height: 100%;
  overflow-y: auto;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    position: absolute;
    z-index: 999;
    top: 4.2rem;
    bottom: 0;
  }
`

export const ContentViewport = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  max-height: 100%;
  overflow: auto;
`

export const Content = styled.main`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 1rem;
  overflow: visible;
  margin-top: 0.2rem;

  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  font-size: 18px;
`
